<template>
  <div>
    <b-col sm="2">
      <b-select v-model="perPage" :options="pageOptions" class="col-7 float-left">
      </b-select>
    </b-col>
    <b-col>
      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" aria-controls="users-table"
        variant="info"></b-pagination>
    </b-col>

    <h6 class="esep-blue-color float-left font-weight-bold">
      {{ $t("roleManagement.searchResult") }}
    </h6>
    <b-table id="users-table" striped hover borderless :items="userList" :fields="fields" :per-page="perPage"
      :current-page="currentPage" selectable :select-mode="'single'" @row-selected="onRowSelected" show-empty responsive
      thead-class="esep-blue-bg br-10 text-light">
      <template v-slot:cell(selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span size="md"> <b-icon icon="person-check-fill"></b-icon> </span>
        </template>
        <template v-else>
          <span size="md"> <b-icon icon="person-check"></b-icon> </span>
        </template>
      </template>

      <template v-slot:cell(enabled)="data">
        <b-icon :icon="data.item.enabled ? 'check-circle-fill' : 'x-circle-fill'"
          :variant="data.item.enabled ? 'success' : 'danger'" v-b-tooltip.hover
          :title="data.item.emailVerified ? 'Ο χρήστης είναι ενεργός' : 'Ο χρήστης δεν είναι ενεργός'" />
      </template>

      <template v-slot:cell(email)="data">
        <b-icon :icon="data.item.emailVerified ? 'check-circle-fill' : 'x-circle-fill'"
          :variant="data.item.emailVerified ? 'success' : 'danger'" v-b-tooltip.hover
          :title="data.item.emailVerified ? 'Το email είναι επιβεβαιωμένο' : 'Το email δεν είναι επιβεβαιωμένο'" /> {{
            data.item.email }}
      </template>

      <template v-slot:cell(username)="data">
        <b-icon v-if="data.item.username !== data.item.email" icon="exclamation-triangle-fill" variant="warning"
          v-b-tooltip.hover title="Το όνομα χρήστη και το email είναι διαφορετικά" />
        {{ data.item.username }}
      </template>

      <template v-slot:empty="">
        {{ $t("roleManagement.userNotFound") }}
      </template>
    </b-table>
  </div>
</template>

<script>
import esepService from "../../services/esep.service";

var rolesTableVisible = false;

export default {
  computed: {
    rows() {
      return this.userList.length
    }
  },
  props: {
    userList: {
      type: Array
    }
  },
  data() {
    return {
      fields:
        [
          { key: 'selected', label: '✔' },
          { key: 'id', label: 'AM', thClass: 'text-left', tdClass: 'text-left' },
          { key: 'orgMember.surName', label: 'Επώνυμο', thClass: 'text-left', tdClass: 'text-left' },
          { key: 'orgMember.firstName', label: 'Όνομα', thClass: 'text-left', tdClass: 'text-left' },
          { key: 'username', label: 'Όνομα χρήστη', thClass: 'text-left', tdClass: 'text-left' },
          { key: 'enabled', label: 'Ενεργός', thClass: 'text-left', tdClass: 'text-left' },
          { key: 'email', label: 'eMail', thClass: 'text-left', tdClass: 'text-left' },
          { key: 'orgMember.orgUnit.name', label: 'Κλιμάκιο', thClass: 'text-left', tdClass: 'text-left' },
        ],
      selected: [],
      rolesTableVisible: false,
      perPage: 10,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100, {
        value: Number.MAX_SAFE_INTEGER,
        text: "All"
      }]
    }
  },
  methods: {
    onRowSelected(row) {
      this.selected = row;
      this.$store.state.selectedUsers = row;
      this.showRoles(row);
    },
    onRowButton(row) {
      if (rolesTableVisible && JSON.stringify(this.selected) == JSON.stringify([row.item] && this.selected.length == 1)) {
        rolesTableVisible = false
      } else {
        this.selected = [row.item];
        this.$store.state.selectedUsers = [row.item];
        this.showRoles(row.item);
      }
      this.$emit("changeVisibility", rolesTableVisible);
    },
    showRoles(selected) {
      if (rolesTableVisible && selected.length < 1) {
        rolesTableVisible = false;
        this.$store.state.selectedUsers = undefined;
        this.$emit('changeVisibility', rolesTableVisible);
      } else {
        esepService.guessRoleUnit(selected[0].username).then(
          (response) => {
            this.$emit('user-selected', { userRoles: response.data, user: selected[0] });
            rolesTableVisible = true;
            this.$emit('changeVisibility', rolesTableVisible);
          }
        )

      }

    }
  }
}
</script>